export const DEFAULT_PER_PAGE_FAQ = 10;

export const GET_FAQ = 'admin/get_faq';
export const CREATE_FAQ = 'admin/faq_create';
export const UPDATE_FAQ = 'admin/faq_update';
export const DELETE_FAQ = 'admin/faq_delete';
export const GET_FAQ_BY_ID = 'admin/get_faq_by_id';
